import React from 'react';

const cate = "About Our School";
const title = "A Friendly School Having Proud of Their Students";
const desc = "At Horizon Academy, we believe every child’s journey begins with a spark—an innate curiosity waiting to be nurtured. Our preschool program welcomes little learners from 18 to 24 months into a world where imagination, discovery, and growth come together in harmony. With a dedicated team of IIMTT Montessori-trained educators, we create a vibrant, nurturing environment that encourages creativity, independence, and holistic development. Beyond early childhood education, Horizon Academy is proud to be a recognized hub for excellence in teacher training, offering internationally accredited programs certified by IIMTT London, London Teacher’s Training Center, and the International Montessori Council. Whether shaping young minds or empowering future educators, Horizon Academy is where every horizon begins with a strong foundation."
const infoTitle = "Call to ask any question";
const phoneNumber = "+91 799-337-67";


const nullaList = [
    {
        imgUrl: 'assets/images/about/icon01.png',
        imgAlt: 'about',
        text: 'Learning Environment',
    },
    {
        imgUrl: 'assets/images/about/icon02.png',
        imgAlt: 'about',
        text: 'Montessori Trained Teachers',
    },
    {
        imgUrl: 'assets/images/about/icon03.png',
        imgAlt: 'about',
        text: 'Overall Development',
    },
    {
        imgUrl: 'assets/images/about/icon04.png',
        imgAlt: 'about',
        text: 'Professional Teaching',
    },
]

const About = () => {
    return (
        <section className="about-section section-right-shape padding-bottom padding-top">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="about-video mr-lg-4">
                            <img src="assets/images/about/about01.jpg" alt="about" />
                            <a href="https://www.youtube.com/embed/FKIVjDS5BJE" className="video-button popup"><i className="flaticon-play"></i></a>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-content">
                            <div className="section-header left-style">
                                <span className="cate mt-0">{cate}</span>
                                <h3 className="title">{title}</h3>
                                <p>{desc}</p>
                            </div>
                            <ul className="nulla-list">
                                {nullaList.map((val, i) => (
                                    <li key={i}>
                                        <div className="thumb">
                                            <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                                        </div>
                                        <div className="content">
                                            {val.text}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <div className="about-contact">
                                <div className="call-item">
                                    <div className="thumb">
                                        <img src="assets/images/about/call.png" alt="about" />
                                    </div>
                                    <div className="content">
                                        <span className="info">{infoTitle}</span>
                                        <h5 className="subtitle"><a href="Tel:+9179933767">{phoneNumber}</a></h5>
                                    </div>
                                </div>
                                <div className="sign">
                                    <img src="assets/images/about/sign.png" alt="about" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About